import React, { useCallback, useMemo } from 'react';
import { batch } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import {
  builderDefaultOptionsSelector,
  builderSelectedOptionsSelector,
} from '../../../../../redux/selectors/builder';
import { assertCondition } from '../../../../../utils/types';
import { QueryType } from '../../../../../utils/apollo/graphqlSchema';
import {
  removeBinning,
  setSubjectAction,
} from '../../../../../redux/slices/oldBuilder';
import BuilderEnumSelect from '../../../../../components/Builder/BuilderFields/BuilderEnumSelect';

const NONE_SUBJECT_KEY = 'NONE';

const HistogramSubject = () => {
  const dispatch = useAppDispatch();

  const defaultOptions = useAppSelector((state) =>
    builderDefaultOptionsSelector(state),
  );
  const selectedOptions = useAppSelector((state) =>
    builderSelectedOptionsSelector(state),
  );

  assertCondition(
    defaultOptions?.type === QueryType.Expression &&
      selectedOptions?.type === QueryType.Expression,
  );

  const { histogramModeConfig } = defaultOptions;

  const subjects = histogramModeConfig.subjects;
  const selectedSubjectKey = selectedOptions.subject;

  const availableSubjects = useMemo(() => {
    // manually filter NONE value from array
    return subjects.filter((subject) => subject.key !== NONE_SUBJECT_KEY);
  }, [subjects]);

  const handleChange = useCallback(
    (subjectKey: string) => {
      batch(() => {
        dispatch(
          setSubjectAction({
            queryType: QueryType.Expression,
            subjectKey,
          }),
        );

        // subject change will reset binning
        dispatch(removeBinning());
      });
    },
    [dispatch],
  );

  return (
    <BuilderEnumSelect
      label={'Subject'}
      enumOptions={availableSubjects}
      selectedOption={selectedSubjectKey}
      onChange={handleChange}
    />
  );
};

export default HistogramSubject;
